import { ReactNode, useState } from "react";
import DynamicIcon from "./dynamic_icon";

interface Props {
  children: JSX.Element
  title: string
  icon: ReactNode;
  defaultOpen?: boolean
  fontWeight?: 'normal' | 'bold'
  textColor?: string
  titleBackgroundColor?: string
}

function IconedCascateList({ title, icon, defaultOpen, children }: Props) {
  const [isOpen, setIsOpen] = useState(defaultOpen ?? false);
  return (
    <div className="w-full flex flex-col bg-light-mode-2 dark:bg-dark-mode-2 rounded-[4px] border-[1px] border-border-light-gray dark:border-border-dark-gray">
      <div className={`w-full h-14 flex justify-between items-center px-6 cursor-pointer bg-light-mode-2 dark:bg-dark-mode-2`}
        onClick={() => setIsOpen(!isOpen)}>
        <div className="w-full flex flex-row gap-2">
          <div className="flex items-center gap-4">
            <div className="w-12 h-12 bg-green-50 rounded-full flex items-center justify-center text-[#00a859]">
              {icon}
            </div>
            <div>
              <h2 className="text-xl font-bold text-gray-800 dark:text-gray-200 m-0">{title}</h2>
            </div>
          </div>
        </div>
        <DynamicIcon nameIcon={isOpen ? "KeyboardArrowDownRounded" : "KeyboardArrowUpRounded"} size={25} className="text-black dark:text-white" />
      </div>
      {
        isOpen === true &&
        <div className="w-full flex justify-between items-center p-6 border-t-[1px] border-border-light-gray dark:border-border-dark-gray">
          {children}
        </div>
      }
    </div >
  );
}

export default IconedCascateList;